
import ssoImg1 from "./../../../../assets/images/intervention-1.png"; // Adjust the path as necessary

function SeaWatchReponseInterventionTab() {


  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SEA WATCH & RESPONSE
        <span className="text-orange-ef3e33 font-400"> intervention </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          
          <p className="mb-3 text-primary-color">The Intervention section is being developed and capacitated to respond to situations developing at sea.  </p>

          <p className="mb-3 text-primary-color">This is where interaction with vessels at sea and organisations ashore are  executed; through radio communication, tasking of the Emergency Towing  Vessel (ETV), initiating the national contingency plan for specific  situations, calling on defence and other resources to assist.</p>



          <p className="font-18 font-900 mb-3">This section is responsible for the following:</p>

          <ul className="green-star-ul">
            <li>Communications – radio communication with vessels at sea</li>
            <li>Emergency Towing Vessel (ETV) deployment for vessels along the SA coastline</li>
            <li>Oil pollution call outs</li>
            <li>Hazardous and Noxious substances (HNS) pollution call outs</li>
          </ul>

        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>
        
      </div>
    </>
  );
}

export default SeaWatchReponseInterventionTab;